<template>
    <div class="report-header">
        <div class="row report-header__logo">
            <div class="col-sm-7">
                <img src="../../../../assets/images/logo--grf.svg" width="155" height="54" alt="" v-if="isGrfSystem">
                <img src="../../../../assets/images/logo--heidiland-invert.svg" width="155" height="54" alt="" v-else-if="isHeidilandSystem">
                <img src="../../../../assets/images/logo.svg" width="155" height="54" alt="" v-else>
            </div>
            <div class="col-sm-5 text-right">
                Digital.Report<br>
                {{ assessment.invoiceDate }}
            </div>
        </div>
        <div class="row report-header__address">
            <div class="col-sm-6">
                Erstellt für:<br>
                <strong>{{ assessment.organisationName }}</strong><br>
                {{ assessment.contactFirstname }} {{ assessment.contactLastname }}
            </div>
            <div class="col-sm-6 text-right">
                Erstellt durch:<br>
                <strong>{{ coach.company }}</strong><br>
                {{ coach.firstname }} {{ coach.lastname }}
            </div>
        </div>

        <div class="report-header__website">
            <img :src="assessment.screenshot" alt="">
        </div>
        <div class="report-header__headline py-5">
            <div class="row">
                <div class="col-10 offset-1"><h1 class="font-weight-bold">CHECK No. <a :href="currentUrl" class="text-white">{{assessment.id}}</a></h1></div>
                <div class="col-md-3 offset-md-1">
                    <span v-if="sector">Branche: {{sector}}</span>
                </div>
                <div class="col-md-7">
                    In diesem Report erhalten eine Übersicht wie es um Ihre digitale Gesundheit steht und Empfehlungen um die eigene Fitness zu verbessern.<br>
                    <br>
                    weitere Infos unter <a :href="appUrl" class="text-white" target="_blank">{{ appUrl }}</a>
                </div>
            </div>
        </div>
        <div class="report-header__coach text-center py-5">
            <p>präsentiert von</p>
            <img :src="coach.companyLogoPath" alt="" v-if="coach.companyLogoPath"/>
            <img src="../../../../assets/images/fallback-companylogo.svg" alt="" v-else/>
            <p>zertifizierter Digital.Fitness® Partner</p>
        </div>
    </div>
</template>

<script>
    import env from '../../../../mixins/env';
    import Assessment from '../../../../models/Assessment';

    export default {
        mixins: [env],

        props: {
            assessment: {
                type: Assessment,
                required: true,
            },
        },

        computed: {
            currentUrl: () => window.location.href,
            appUrl: () => window.location.origin,
        },

        asyncComputed: {
            sector: async vm => (vm.assessment.sector ? (await vm.assessment.getSector()).title : null),
            coach: {
                get: vm => vm.assessment.getCoach(),
                default: {},
            },
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss">
    .report-header {
        &__logo {
            margin-bottom: 5rem !important;
        }

        &__address {
            margin-bottom: 5rem !important;
        }

        &__website {
            position: relative;
            width: 100%;
            height: 0;
            padding-bottom: 58.1%;
            background: url("../../../../assets/images/report.svg") left top no-repeat;
            background-size: contain;

            @if(env('VUE_APP_ENV') == 'grf') {
                background-image: url("../../../../assets/images/report--grf.svg");
            }

            @if(env('VUE_APP_ENV') == 'heidiland') {
                background-image: url("../../../../assets/images/report--heidiland.png");
            }

            img {
                position: absolute;
                left: 36.1%;
                top: 29%;
                width: 52.8%;
            }
        }

        &__headline {
            color: #fff;
            z-index: 10;

            @if(env('VUE_APP_ENV') == 'grf') {
                background: #FFB70F;
            } @else if(env('VUE_APP_ENV') == 'heidiland') {
                background: #f20026;
            } @else {
                background: #6bbb7f;
            }
        }

        &__coach {
            margin-top: 5rem !important;
        }
    }
</style>
